<template>
  <DepartmentsDetail :departmentId="departmentId" />
</template>

<script>
import DepartmentsDetail from "@/components/DepartmentsDetail/index.vue";
export default {
  components: {
    DepartmentsDetail,
  },
  data() {
    return {
      departmentId: this.$route.params.departmentId,
    };
  },
};
</script>

<style></style>
